import { render, staticRenderFns } from "./qita.vue?vue&type=template&id=62761735&scoped=true"
import script from "./qita.vue?vue&type=script&lang=js"
export * from "./qita.vue?vue&type=script&lang=js"
import style0 from "./qita.vue?vue&type=style&index=0&id=62761735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62761735",
  null
  
)

export default component.exports